// extracted by mini-css-extract-plugin
export default {"container":"Modal_container__nuzHS","box":"Modal_box__8-oZG","close":"Modal_close__eX4BN","hidden":"Modal_hidden__DwM-W"};